import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import { SubscriptionDisclaimerData } from './utils';

interface SubscriptionDisclaimerProps {
  disclaimerData: SubscriptionDisclaimerData;
}

// ROSCA/FTC legal disclaimer (ACDEV-26078): must be visible before the player
// confirms a subscription purchase, for every payment method.
export function SubscriptionDisclaimer({ disclaimerData }: SubscriptionDisclaimerProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });

  return (
    <Box
      pb={2}
      fontSize={'12px'}
      textAlign={'left'}
      color={'#323241'}
      data-testid="subscription-renewal-disclaimer"
    >
      {t('subscriptionRenewalDisclaimer', {
        period: t(disclaimerData.renewalPeriodKey),
        amount: disclaimerData.amount,
        taxes: t(disclaimerData.taxesKey),
      })}
    </Box>
  );
}
